import React from 'react';
import { useNavigation } from '../../contexts/NavigationContext';

interface RouterLinkProps {
  to: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
  onClick?: (e: React.MouseEvent) => void;
}

/**
 * Custom Link component that uses NavigationContext instead of react-router
 * This makes the component router-agnostic
 */
export const RouterLink: React.FC<RouterLinkProps> = ({
  to,
  children,
  style,
  onClick,
}) => {
  const { navigateToTab } = useNavigation();

  const handleClick = (e: React.MouseEvent) => {
    // Call the original onClick handler first
    if (onClick) {
      onClick(e);
    }

    // If not prevented, handle navigation
    if (!e.defaultPrevented) {
      e.preventDefault();

      // Extract tab from the URL pattern: /cases/{id}?tab={tab}
      const tabMatch = to.match(/tab=([^&]+)/);
      if (tabMatch) {
        const tab = tabMatch[1];
        navigateToTab(tab as any); // Cast to avoid strict type checking
      }
    }
  };

  return (
    <a
      href={to}
      style={{
        textDecoration: 'none',
        color: 'inherit',
        ...style,
      }}
      onClick={handleClick}
    >
      {children}
    </a>
  );
};
